/**
 * Created by Languagenut on 17/09/2019.
 */


import React  from 'react';
import TotalsBlock from '../charts/totals_block.js';
import Radar from '../charts/skills_radar.js';
import LearntLine from '../charts/learnt_line.js';
import Bar from '../charts/learnt_bar.js';
import Translation from  '../../store/internationalization-store.js';
import {Card , Row , Col} from 'react-bootstrap'
import ProgressTable from  '../widgets/new_progress_table.js';
import StatisticsService from '../../services/statistics-service.js';

export default class Overview extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            generalStatistics:{},
            rankingData:[],
            averageValues:[], 
            learntData:{}
        };
    }

    updateStuff() {
        StatisticsService.getUserGeneralStatistics(this.props.studentUid).then(function(response) {
            this.setState({generalStatistics:response.generalStatistics});
        }.bind(this));

        StatisticsService.getUserRanking(this.props.studentUid).then(function(response) {
            this.setState({rankingData:response.scores});
        }.bind(this));

        StatisticsService.getUserLearnt(this.props.studentUid).then(function(response) {
            this.setState({learntData:response.learntValues});
        }.bind(this));

        StatisticsService.getUserAverageValues(this.props.studentUid).then(function(response) {
            this.setState({averageValues:response.averageValues});
        }.bind(this));
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.updateStuff();
        this.setState({
            "update":true
        });
    }

    componentDidMount() {
        this.updateStuff();
    }

    generateLabels() {
        var month = new Date().getMonth();
        var baseThing = [Translation.get(605 ,'January'), Translation.get(606 ,'February'), Translation.get(607 ,'March'), Translation.get(608 ,'April'), Translation.get(609 ,'May'), Translation.get(610 ,'June'), Translation.get(611 ,'July' ),Translation.get(612 ,'August'),Translation.get(613 ,'September'),Translation.get(614 ,'October'),Translation.get(615,'November') , Translation.get(616 ,'December')];
    
        var shiftedMonths = baseThing.splice(month+1, baseThing.length-month+1);
        return shiftedMonths.concat(baseThing);
    }

    generateData(learntData) {
        var labels = [];
        var dataMonthly = [];
        var dataTotal = [];
        if (learntData == undefined || learntData.vocabValuesTotal == undefined) {
            return [[],[],[]];
        } 

        if (learntData.vocabValuesTotal != null) {
            labels.push(Translation.get(12233 , 'Vocabulary'));
            dataMonthly.push(learntData.vocabValuesMonthly);
            dataTotal.push(learntData.vocabValuesTotal);
        }

        if (learntData.sentenceValuesTotal != null) {
            labels.push(Translation.get(89 , 'Sentence Building'));
            dataMonthly.push(learntData.sentenceValuesMonthly);
            dataTotal.push(learntData.sentenceValuesTotal);
        }

        if (learntData.grammarValuesTotal != null) {
            labels.push(Translation.get(100 , 'Grammar'));
            dataMonthly.push(learntData.grammarValuesMonthly);
            dataTotal.push(learntData.grammarValuesTotal);
        }

        if (learntData.verbValuesTotal != null) {
            labels.push(Translation.get(1026 , 'Verbs'));
            dataMonthly.push(learntData.verbValuesMonthly);
            dataTotal.push(learntData.verbValuesTotal);
        }

        return [labels, dataMonthly, dataTotal];
    }

    generateSkillsData() {
        var data = [];
        var labels = [];
        var values = this.state.averageValues;

        if (values.reading != null) {
            data.push(values.reading);
            labels.push(Translation.get('119' , 'Reading'));
        }

        if (values.listening != null) {
            data.push(values.listening);
            labels.push(Translation.get('117' , 'Listening'));
        }

        if (values.speaking != null) {
            data.push(values.speaking);
            labels.push(Translation.get('118' , 'Speaking'));
        }

        if (values.writing != null) {
            data.push(values.writing);
            labels.push(Translation.get('120' , 'Writing'));
        }

        if (values.sentence != null) {
            data.push(values.sentence);
            labels.push(Translation.get('89' , 'Sentence Building'));
        }

        if (values.grammar != null) {
            data.push(values.grammar);
            labels.push(Translation.get('100' , 'Grammar'));
        }

        if (values.verbs != null) {
            data.push(values.verbs);
            labels.push(Translation.get('1026' , 'Verbs'));
        }

        return [data, labels];
    }

    generateSkillsDiamond() {
        var vocab = undefined;
        var exam = undefined;
        var values = this.state.averageValues;
        if (values == undefined) {
            return [vocab, exam]; 
        }
        if (values.vocabReading != null && values.vocabReading != undefined) {
            vocab = {reading:values.vocabReading, writing:values.vocabWriting, 
                listening:values.vocabListening, speaking:values.vocabSpeaking};
        }

        if (values.examReading != null && values.examReading != undefined) {
            exam = {reading:values.examReading, writing:values.examWriting, 
                listening:values.examListening, speaking:values.examSpeaking};
        }
        return [vocab, exam];
    }

    render(){
        var totalData = this.generateData(this.state.learntData);
        var skillsData = this.generateSkillsData();
        var diamondData = this.generateSkillsDiamond();
        var titleTranslation = Translation.get(12783 , 'Exam Skills % Correct Answers');
        if (diamondData[1] == undefined) {
            titleTranslation = Translation.get(12784 , 'Vocab Skills % Correct Answers');
        }
        return <div>
            <Row>
                <Col md={12}>
                    <TotalsBlock isStudent={true} statistics={this.state.generalStatistics}/>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col md={6}>
                    <Card body>
                        <h6>{Translation.get(12785 , 'Cumulative Learnt Totals')}</h6>
                        <LearntLine 
                            labels={this.generateLabels()}
                            lines={totalData[0]}
                            data={totalData[2]}/>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card body>
                        <h6>{Translation.get(12773 , 'Skills Average %')}</h6>
                        <Bar data={skillsData[0]} labels={skillsData[1]}/>
                    </Card>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col md={7}>
                    <Card body>
                        <h6>{Translation.get(12774 , 'Monthly Totals')}</h6>
                        <LearntLine 
                            labels={this.generateLabels()}
                            lines={totalData[0]}
                            data={totalData[1]}/>
                    </Card>
                </Col>
                <Col md={5}>
                    <Card body>
                        <h6>{titleTranslation}</h6>
                        <Radar vocabulary={diamondData[0]} exam={diamondData[1]}/>
                    </Card>
                </Col>
            </Row>
            <ProgressTable languages={this.props.languages} studentUid={this.props.studentUid}/>
        </div>
    }
}